const points = [
  {
    icon: 'ri-search-line',
    title: 'İşe Özel Değerlendirme',
    desc: 'Her alan kendi şartlarına göre değerlendirilir.',
  },
  {
    icon: 'ri-team-line',
    title: 'Profesyonel Ekip',
    desc: 'Hizmet, temizlik işine uygun ekip planlamasıyla yürütülür.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Profesyonel Ekipman',
    desc: 'İşin ihtiyacına uygun ekipman kullanılır.',
  },
  {
    icon: 'ri-shopping-bag-3-line',
    title: 'Malzemeli Hizmet',
    desc: 'Temizlik operasyonu için gerekli profesyonel çalışma altyapısı sağlanır.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Sonuç Odaklı Çalışma',
    desc: 'Standart saatlik paket yerine yapılacak işin kapsamı esas alınır.',
  },
];

export default function WhyViaypii() {
  return (
    <section id="neden-viaypii" className="bg-navy-dark py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            NEDEN <span className="text-gold">VİAYPİİ?</span>
          </h2>
          <p className="text-white/60 text-base md:text-lg max-w-xl mx-auto">
            Profesyonel temizlik hizmetinde fark yaratan yaklaşımımız.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {points.map((point) => (
            <div
              key={point.title}
              className="bg-navy/50 border border-white/10 rounded-lg p-6 md:p-8 hover:border-gold/30 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center text-gold mb-4">
                <i className={`${point.icon} text-3xl`}></i>
              </div>
              <h3 className="font-display text-xl font-bold text-white mb-3">
                {point.title}
              </h3>
              <p className="text-white/60 text-sm md:text-base leading-relaxed">
                {point.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}